const category = window.eventCategory || 'view_layout';
const action = 'plan_3d';

const defaultControlEvent = {
  category,
  action,
};

export const CONTROLS_EVENTS_GA = {
  LOGO: {
    ...defaultControlEvent,
    label: 'logo',
  },
  FULLSCREEN: {
    ...defaultControlEvent,
    label: 'fullscreen',
  },
  SCREENSHOT: {
    ...defaultControlEvent,
    label: 'screenshot',
  },
  TIME_MORNING: {
    ...defaultControlEvent,
    label: 'time_morning',
  },
  TIME_DAY: {
    ...defaultControlEvent,
    label: 'time_day',
  },
  TIME_EVENING: {
    ...defaultControlEvent,
    label: 'time_evening',
  },
  MOVEMODES_WALK: {
    ...defaultControlEvent,
    label: 'movemodes_walk',
  },
  MOVEMODES_ORBIT: {
    ...defaultControlEvent,
    label: 'movemodes_orbit',
  },
  MOVEMODES_FLY: {
    ...defaultControlEvent,
    label: 'movemodes_fly',
  },
  FLOOR_ARROW_UP: {
    ...defaultControlEvent,
    label: 'floot_arrow_up',
  },
  FLOOR_ARROW_DOWN: {
    ...defaultControlEvent,
    label: 'floot_arrow_down',
  },
  FLOOR_ITEM: {
    ...defaultControlEvent,
    label: 'floor_item',
  },
};
